import { missionService } from '../services/mission.service';
import { useApi } from './use-api';

export function useMission(missionId: string | undefined) {
  const { loading, result: mission, error } = useApi(missionService.get, missionId);
  return { loading, mission, error };
}
